// extracted by mini-css-extract-plugin
export default {"container":"LastRotation_container__h9bLw","infoText":"LastRotation_infoText__aIvAf","buttons":"LastRotation_buttons__2AOel"};